// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 入驻页优化 */
.join-page { min-height:100vh; background:var(--color-bg); }

.tabs { display:flex; gap:10px; background:var(--color-surface); padding:14px 14px; border-radius:20px; margin:16px 0 20px; box-shadow:var(--shadow-sm); border:1px solid var(--color-border); position:sticky; top:0; z-index:5; backdrop-filter:saturate(180%) blur(8px); }
.tab {
  flex: 1 1;
  background: var(--color-surface-alt);
  border: 1px solid var(--color-border);
  border-radius: 14px;
  padding: 12px 10px;
  font-size: .85rem;
  color: var(--color-text-sec);
  cursor: pointer;
  font-weight: 600;
  letter-spacing: .3px;
  transition: var(--transition-fast);
  position: relative;
  overflow: hidden;
  min-height: 48px; /* 确保触摸目标 */
  min-width: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.tab:hover { background:#eceff4; color:var(--color-text); }
.tab.active { color:#fff; box-shadow:0 4px 14px -6px rgba(99,102,241,.55); }

/* 分组卡片 */
.join-form .group { border-radius:26px; padding:26px 22px 30px; margin:0 0 26px; position:relative; overflow:hidden; }
.join-form .group::before { content:""; position:absolute; inset:0; background:radial-gradient(circle at 90% 15%,rgba(99,102,241,.18),rgba(255,255,255,0)); pointer-events:none; }
.join-form .group .section-title { font-size:1rem; font-weight:700; color:var(--color-text); margin:0 0 18px; position:relative; display:inline-flex; align-items:center; gap:8px; }
.join-form .group .section-title::after { content:""; height:6px; width:6px; background:linear-gradient(135deg,var(--color-primary),var(--color-primary-accent)); border-radius:50%; box-shadow:0 0 0 4px rgba(99,102,241,.2); }

.join-form .grid { display:flex; flex-direction:column; gap:18px; }
.form-group { display:flex; flex-direction:column; width:100%; animation:fadeSlideUp .6s both; }
.form-group.full { width:100%; }
.form-group label { margin:0 0 8px; color:var(--color-text); font-size:.8rem; font-weight:600; letter-spacing:.4px; text-transform:uppercase; opacity:.85; }
.form-group input, .form-group textarea { font-size:.9rem; min-height:48px; }
.form-group textarea { min-height:90px; resize:vertical; }

/* 上传控件 */
.upload-box { min-height:86px; border:2px dashed var(--color-border-strong); border-radius:18px; display:flex; align-items:center; justify-content:center; color:var(--color-muted); background:var(--color-surface-alt); padding:12px 16px; position:relative; transition:var(--transition-base); cursor:pointer; }
.upload-box:hover { background:#eceff4; }
.upload-box.drag { background:#f0f3ff; border-color:var(--color-primary); box-shadow:0 0 0 4px rgba(99,102,241,.25) inset; }
.upload-box.has-file { justify-content:flex-start; }
.upload-placeholder { text-align:center; font-size:.7rem; letter-spacing:.5px; line-height:1.4; }
.upload-icon { font-size:20px; margin:0 0 6px; display:block; }
.upload-preview { display:flex; gap:14px; align-items:center; width:100%; }
.upload-thumb { width:88px; height:66px; border-radius:14px; overflow:hidden; background:#fff; box-shadow:0 4px 12px -6px rgba(0,0,0,.25); }
.upload-thumb img { width:100%; height:100%; object-fit:cover; display:block; }
.upload-meta { flex:1 1; display:flex; justify-content:space-between; gap:10px; align-items:center; }
.file-name { font-size:.7rem; color:var(--color-text-sec); white-space:nowrap; text-overflow:ellipsis; overflow:hidden; font-weight:600; letter-spacing:.5px; }
.btn-mini { padding:6px 12px; border-radius:10px; border:1px solid var(--color-border-strong); background:var(--color-surface); color:var(--color-text-sec); cursor:pointer; font-size:.65rem; font-weight:600; letter-spacing:.5px; transition:var(--transition-fast); }
.btn-mini:hover { background:var(--color-surface-alt); color:var(--color-text); }
.btn-mini.danger { border-color:#f3b3b3; color:#b02a37; }
.btn-mini.danger:hover { background:#fde7ea; }
.hidden-file-input { display:none; }
.upload-error { position:absolute; left:0; right:0; bottom:-18px; font-size:.65rem; color:#b02a37; text-align:center; animation:fadeSlideUp .5s both; }

/* 提交按钮 */
.submit-btn { width:100%; padding:18px 20px; border-radius:20px; font-size:1rem; font-weight:600; letter-spacing:.5px; margin:12px 0 14px; }

@media (max-width:640px) {
	.join-form .group { padding:24px 20px 26px; }
	.join-form .grid { gap:16px; }
	.tabs { top:0; }
}

@media (max-width: 480px) {
  .tabs {
    padding: 10px 10px;
    gap: 8px;
  }

  .tab {
    padding: 14px 10px;
    font-size: .75rem;
    min-height: 48px; /* 确保触摸目标 */
    min-width: 60px;
  }

  .upload-thumb {
    width: 72px;
    height: 54px;
  }

  .form-group input, .form-group textarea {
    min-height: 48px;
    font-size: 16px; /* 防止iOS缩放 */
  }

  .btn-mini {
    min-height: 36px;
    padding: 8px 12px;
    font-size: .7rem;
  }
}

/* 超小屏优化 */
@media (max-width: 360px) {
  .tab {
    padding: 12px 8px;
    font-size: .7rem;
    min-height: 44px;
    min-width: 50px;
  }

  .upload-thumb {
    width: 64px;
    height: 48px;
  }
}

/* 触摸设备优化 */
@media (pointer: coarse) {
  .tab {
    min-height: 52px;
    padding: 16px 12px;
  }

  .form-group input, .form-group textarea {
    min-height: 52px;
    padding: 16px;
  }

  .btn-mini {
    min-height: 40px;
    padding: 10px 16px;
  }

  .upload-box {
    min-height: 100px;
    padding: 16px;
  }
}

/* ==========================================================
   用户协议样式
   ========================================================== */

/* 协议勾选区域 */
.agreement-section {
  margin: 24px 0 20px;
  padding: 16px 20px;
  background: var(--color-surface);
  border-radius: 16px;
  border: 1px solid var(--color-border);
  box-shadow: var(--shadow-sm);
}

.agreement-checkbox {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  cursor: pointer;
  line-height: 1.5;
  font-size: 0.9rem;
  color: var(--color-text);
}

.agreement-checkbox input[type="checkbox"] {
  display: none;
}

.checkmark {
  width: 20px;
  height: 20px;
  border: 2px solid var(--color-border-strong);
  border-radius: 4px;
  background: var(--color-surface);
  position: relative;
  flex-shrink: 0;
  transition: var(--transition-fast);
  margin-top: 2px;
}

.checkmark::after {
  content: '';
  position: absolute;
  left: 6px;
  top: 2px;
  width: 6px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
  opacity: 0;
  transition: var(--transition-fast);
}

.agreement-checkbox input[type="checkbox"]:checked + .checkmark {
  background: var(--color-primary);
  border-color: var(--color-primary);
}

.agreement-checkbox input[type="checkbox"]:checked + .checkmark::after {
  opacity: 1;
}

.agreement-text {
  flex: 1 1;
  -webkit-user-select: none;
          user-select: none;
}

.agreement-link {
  background: none;
  border: none;
  color: var(--color-primary);
  text-decoration: underline;
  cursor: pointer;
  font-size: inherit;
  font-family: inherit;
  padding: 0;
  margin: 0;
  transition: var(--transition-fast);
}

.agreement-link:hover {
  color: var(--color-primary-accent);
  text-decoration: none;
}

/* 模态框样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
  backdrop-filter: blur(4px);
}

.modal-content {
  background: var(--color-surface);
  border-radius: 20px;
  box-shadow: var(--shadow-lg);
  max-width: 800px;
  width: 100%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  border: 1px solid var(--color-border);
}

.agreement-modal {
  max-width: 900px;
}

.modal-header {
  padding: 20px 24px 16px;
  border-bottom: 1px solid var(--color-border);
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
}

.modal-header h2 {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--color-text);
  line-height: 1.3;
}

.modal-close {
  background: none;
  border: none;
  font-size: 1.8rem;
  color: var(--color-text-sec);
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 8px;
  transition: var(--transition-fast);
  min-width: 36px;
  min-height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-close:hover {
  background: var(--color-surface-alt);
  color: var(--color-text);
}

.modal-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 20px 24px;
}

.agreement-content {
  line-height: 1.6;
  color: var(--color-text);
  font-size: 0.9rem;
}

.agreement-content p {
  margin: 0 0 12px;
  word-wrap: break-word;
}

.agreement-content p.empty-line {
  margin: 8px 0;
  height: 8px;
}

.agreement-content p:first-child {
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--color-primary);
  text-align: center;
  margin-bottom: 20px;
}

.modal-footer {
  padding: 16px 24px 20px;
  border-top: 1px solid var(--color-border);
  display: flex;
  justify-content: center;
  flex-shrink: 0;
}

.modal-btn {
  padding: 12px 32px;
  font-size: 1rem;
  border-radius: 12px;
  min-width: 120px;
}

/* 提交按钮状态 */
.submit-btn:disabled {
  background: var(--color-surface-alt) !important;
  color: var(--color-text-sec) !important;
  cursor: not-allowed !important;
  opacity: 0.6;
}

/* 移动端响应式优化 */
@media (max-width: 480px) {
  .agreement-section {
    margin: 20px 0 16px;
    padding: 14px 16px;
    border-radius: 14px;
  }

  .agreement-checkbox {
    gap: 10px;
    font-size: 0.85rem;
  }

  .checkmark {
    width: 18px;
    height: 18px;
  }

  .checkmark::after {
    left: 5px;
    top: 1px;
    width: 5px;
    height: 9px;
  }

  .modal-overlay {
    padding: 16px;
  }

  .modal-content {
    border-radius: 16px;
    max-height: 85vh;
  }

  .modal-header {
    padding: 16px 18px 12px;
  }

  .modal-header h2 {
    font-size: 1rem;
    line-height: 1.4;
  }

  .modal-close {
    font-size: 1.6rem;
    min-width: 32px;
    min-height: 32px;
  }

  .modal-body {
    padding: 16px 18px;
  }

  .agreement-content {
    font-size: 0.85rem;
    line-height: 1.5;
  }

  .agreement-content p:first-child {
    font-size: 1rem;
  }

  .modal-footer {
    padding: 12px 18px 16px;
  }

  .modal-btn {
    padding: 10px 24px;
    font-size: 0.9rem;
    min-width: 100px;
  }
}

@media (max-width: 360px) {
  .agreement-section {
    padding: 12px 14px;
  }

  .agreement-checkbox {
    font-size: 0.8rem;
    gap: 8px;
  }

  .checkmark {
    width: 16px;
    height: 16px;
  }

  .checkmark::after {
    left: 4px;
    top: 1px;
    width: 4px;
    height: 8px;
  }

  .modal-overlay {
    padding: 12px;
  }

  .modal-header {
    padding: 14px 16px 10px;
  }

  .modal-header h2 {
    font-size: 0.95rem;
  }

  .modal-body {
    padding: 14px 16px;
  }

  .agreement-content {
    font-size: 0.8rem;
  }

  .modal-footer {
    padding: 10px 16px 14px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/JoinPage.css"],"names":[],"mappings":"AAAA,UAAU;AACV,aAAa,gBAAgB,EAAE,0BAA0B,EAAE;;AAE3D,QAAQ,YAAY,EAAE,QAAQ,EAAE,+BAA+B,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,2BAA2B,EAAE,oCAAoC,EAAE,eAAe,EAAE,KAAK,EAAE,SAAS,EAAE,wCAAwC,EAAE;AAC5Q;EACE,SAAO;EACP,oCAAoC;EACpC,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB,EAAE,WAAW;EAC7B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA,aAAa,kBAAkB,EAAE,uBAAuB,EAAE;AAC1D,cAAc,UAAU,EAAE,+CAA+C,EAAE;;AAE3E,SAAS;AACT,oBAAoB,kBAAkB,EAAE,sBAAsB,EAAE,eAAe,EAAE,iBAAiB,EAAE,eAAe,EAAE;AACrH,4BAA4B,UAAU,EAAE,iBAAiB,EAAE,OAAO,EAAE,sFAAsF,EAAE,mBAAmB,EAAE;AACjL,mCAAmC,cAAc,EAAE,eAAe,EAAE,uBAAuB,EAAE,eAAe,EAAE,iBAAiB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,OAAO,EAAE;AACnL,0CAA0C,UAAU,EAAE,UAAU,EAAE,SAAS,EAAE,mFAAmF,EAAE,iBAAiB,EAAE,wCAAwC,EAAE;;AAE/N,mBAAmB,YAAY,EAAE,qBAAqB,EAAE,QAAQ,EAAE;AAClE,cAAc,YAAY,EAAE,qBAAqB,EAAE,UAAU,EAAE,8BAA8B,EAAE;AAC/F,mBAAmB,UAAU,EAAE;AAC/B,oBAAoB,cAAc,EAAE,uBAAuB,EAAE,eAAe,EAAE,eAAe,EAAE,mBAAmB,EAAE,wBAAwB,EAAE,WAAW,EAAE;AAC3J,0CAA0C,eAAe,EAAE,eAAe,EAAE;AAC5E,uBAAuB,eAAe,EAAE,eAAe,EAAE;;AAEzD,SAAS;AACT,cAAc,eAAe,EAAE,4CAA4C,EAAE,kBAAkB,EAAE,YAAY,EAAE,kBAAkB,EAAE,sBAAsB,EAAE,wBAAwB,EAAE,mCAAmC,EAAE,iBAAiB,EAAE,iBAAiB,EAAE,iCAAiC,EAAE,cAAc,EAAE;AACnT,oBAAoB,kBAAkB,EAAE;AACxC,mBAAmB,kBAAkB,EAAE,iCAAiC,EAAE,+CAA+C,EAAE;AAC3H,uBAAuB,0BAA0B,EAAE;AACnD,sBAAsB,iBAAiB,EAAE,eAAe,EAAE,mBAAmB,EAAE,eAAe,EAAE;AAChG,eAAe,cAAc,EAAE,cAAc,EAAE,aAAa,EAAE;AAC9D,kBAAkB,YAAY,EAAE,QAAQ,EAAE,kBAAkB,EAAE,UAAU,EAAE;AAC1E,gBAAgB,UAAU,EAAE,WAAW,EAAE,kBAAkB,EAAE,eAAe,EAAE,eAAe,EAAE,0CAA0C,EAAE;AAC3I,oBAAoB,UAAU,EAAE,WAAW,EAAE,gBAAgB,EAAE,aAAa,EAAE;AAC9E,eAAe,QAAM,EAAE,YAAY,EAAE,6BAA6B,EAAE,QAAQ,EAAE,kBAAkB,EAAE;AAClG,aAAa,eAAe,EAAE,2BAA2B,EAAE,kBAAkB,EAAE,sBAAsB,EAAE,eAAe,EAAE,eAAe,EAAE,mBAAmB,EAAE;AAC9J,YAAY,gBAAgB,EAAE,kBAAkB,EAAE,2CAA2C,EAAE,+BAA+B,EAAE,2BAA2B,EAAE,cAAc,EAAE,gBAAgB,EAAE,eAAe,EAAE,mBAAmB,EAAE,iCAAiC,EAAE;AACxQ,kBAAkB,mCAAmC,EAAE,uBAAuB,EAAE;AAChF,mBAAmB,oBAAoB,EAAE,aAAa,EAAE;AACxD,yBAAyB,kBAAkB,EAAE;AAC7C,qBAAqB,YAAY,EAAE;AACnC,gBAAgB,iBAAiB,EAAE,MAAM,EAAE,OAAO,EAAE,YAAY,EAAE,gBAAgB,EAAE,aAAa,EAAE,iBAAiB,EAAE,8BAA8B,EAAE;;AAEtJ,SAAS;AACT,cAAc,UAAU,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,cAAc,EAAE,eAAe,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;;AAE3I;CACC,oBAAoB,sBAAsB,EAAE;CAC5C,mBAAmB,QAAQ,EAAE;CAC7B,QAAQ,KAAK,EAAE;AAChB;;AAEA;EACE;IACE,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB,EAAE,WAAW;IAC7B,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,eAAe,EAAE,YAAY;EAC/B;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;EAClB;AACF;;AAEA,UAAU;AACV;EACE;IACE,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,WAAW;AACX;EACE;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;AACF;;AAEA;;+DAE+D;;AAE/D,WAAW;AACX;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4CAA4C;EAC5C,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;EAClB,cAAc;EACd,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,wBAAwB;EACxB,UAAU;EACV,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAO;EACP,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;EACV,SAAS;EACT,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,yCAAyC;EACzC,aAAa;EACb,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,+CAA+C;EAC/C,uCAAuC;EACvC,8BAA8B;EAC9B,YAAY;AACd;;AAEA,aAAa;AACb;EACE;IACE,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,SAAS;IACT,QAAQ;IACR,UAAU;IACV,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,SAAS;IACT,QAAQ;IACR,UAAU;IACV,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;EACzB;AACF","sourcesContent":["/* 入驻页优化 */\n.join-page { min-height:100vh; background:var(--color-bg); }\n\n.tabs { display:flex; gap:10px; background:var(--color-surface); padding:14px 14px; border-radius:20px; margin:16px 0 20px; box-shadow:var(--shadow-sm); border:1px solid var(--color-border); position:sticky; top:0; z-index:5; backdrop-filter:saturate(180%) blur(8px); }\n.tab {\n  flex: 1;\n  background: var(--color-surface-alt);\n  border: 1px solid var(--color-border);\n  border-radius: 14px;\n  padding: 12px 10px;\n  font-size: .85rem;\n  color: var(--color-text-sec);\n  cursor: pointer;\n  font-weight: 600;\n  letter-spacing: .3px;\n  transition: var(--transition-fast);\n  position: relative;\n  overflow: hidden;\n  min-height: 48px; /* 确保触摸目标 */\n  min-width: 80px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.tab:hover { background:#eceff4; color:var(--color-text); }\n.tab.active { color:#fff; box-shadow:0 4px 14px -6px rgba(99,102,241,.55); }\n\n/* 分组卡片 */\n.join-form .group { border-radius:26px; padding:26px 22px 30px; margin:0 0 26px; position:relative; overflow:hidden; }\n.join-form .group::before { content:\"\"; position:absolute; inset:0; background:radial-gradient(circle at 90% 15%,rgba(99,102,241,.18),rgba(255,255,255,0)); pointer-events:none; }\n.join-form .group .section-title { font-size:1rem; font-weight:700; color:var(--color-text); margin:0 0 18px; position:relative; display:inline-flex; align-items:center; gap:8px; }\n.join-form .group .section-title::after { content:\"\"; height:6px; width:6px; background:linear-gradient(135deg,var(--color-primary),var(--color-primary-accent)); border-radius:50%; box-shadow:0 0 0 4px rgba(99,102,241,.2); }\n\n.join-form .grid { display:flex; flex-direction:column; gap:18px; }\n.form-group { display:flex; flex-direction:column; width:100%; animation:fadeSlideUp .6s both; }\n.form-group.full { width:100%; }\n.form-group label { margin:0 0 8px; color:var(--color-text); font-size:.8rem; font-weight:600; letter-spacing:.4px; text-transform:uppercase; opacity:.85; }\n.form-group input, .form-group textarea { font-size:.9rem; min-height:48px; }\n.form-group textarea { min-height:90px; resize:vertical; }\n\n/* 上传控件 */\n.upload-box { min-height:86px; border:2px dashed var(--color-border-strong); border-radius:18px; display:flex; align-items:center; justify-content:center; color:var(--color-muted); background:var(--color-surface-alt); padding:12px 16px; position:relative; transition:var(--transition-base); cursor:pointer; }\n.upload-box:hover { background:#eceff4; }\n.upload-box.drag { background:#f0f3ff; border-color:var(--color-primary); box-shadow:0 0 0 4px rgba(99,102,241,.25) inset; }\n.upload-box.has-file { justify-content:flex-start; }\n.upload-placeholder { text-align:center; font-size:.7rem; letter-spacing:.5px; line-height:1.4; }\n.upload-icon { font-size:20px; margin:0 0 6px; display:block; }\n.upload-preview { display:flex; gap:14px; align-items:center; width:100%; }\n.upload-thumb { width:88px; height:66px; border-radius:14px; overflow:hidden; background:#fff; box-shadow:0 4px 12px -6px rgba(0,0,0,.25); }\n.upload-thumb img { width:100%; height:100%; object-fit:cover; display:block; }\n.upload-meta { flex:1; display:flex; justify-content:space-between; gap:10px; align-items:center; }\n.file-name { font-size:.7rem; color:var(--color-text-sec); white-space:nowrap; text-overflow:ellipsis; overflow:hidden; font-weight:600; letter-spacing:.5px; }\n.btn-mini { padding:6px 12px; border-radius:10px; border:1px solid var(--color-border-strong); background:var(--color-surface); color:var(--color-text-sec); cursor:pointer; font-size:.65rem; font-weight:600; letter-spacing:.5px; transition:var(--transition-fast); }\n.btn-mini:hover { background:var(--color-surface-alt); color:var(--color-text); }\n.btn-mini.danger { border-color:#f3b3b3; color:#b02a37; }\n.btn-mini.danger:hover { background:#fde7ea; }\n.hidden-file-input { display:none; }\n.upload-error { position:absolute; left:0; right:0; bottom:-18px; font-size:.65rem; color:#b02a37; text-align:center; animation:fadeSlideUp .5s both; }\n\n/* 提交按钮 */\n.submit-btn { width:100%; padding:18px 20px; border-radius:20px; font-size:1rem; font-weight:600; letter-spacing:.5px; margin:12px 0 14px; }\n\n@media (max-width:640px) {\n\t.join-form .group { padding:24px 20px 26px; }\n\t.join-form .grid { gap:16px; }\n\t.tabs { top:0; }\n}\n\n@media (max-width: 480px) {\n  .tabs {\n    padding: 10px 10px;\n    gap: 8px;\n  }\n\n  .tab {\n    padding: 14px 10px;\n    font-size: .75rem;\n    min-height: 48px; /* 确保触摸目标 */\n    min-width: 60px;\n  }\n\n  .upload-thumb {\n    width: 72px;\n    height: 54px;\n  }\n\n  .form-group input, .form-group textarea {\n    min-height: 48px;\n    font-size: 16px; /* 防止iOS缩放 */\n  }\n\n  .btn-mini {\n    min-height: 36px;\n    padding: 8px 12px;\n    font-size: .7rem;\n  }\n}\n\n/* 超小屏优化 */\n@media (max-width: 360px) {\n  .tab {\n    padding: 12px 8px;\n    font-size: .7rem;\n    min-height: 44px;\n    min-width: 50px;\n  }\n\n  .upload-thumb {\n    width: 64px;\n    height: 48px;\n  }\n}\n\n/* 触摸设备优化 */\n@media (pointer: coarse) {\n  .tab {\n    min-height: 52px;\n    padding: 16px 12px;\n  }\n\n  .form-group input, .form-group textarea {\n    min-height: 52px;\n    padding: 16px;\n  }\n\n  .btn-mini {\n    min-height: 40px;\n    padding: 10px 16px;\n  }\n\n  .upload-box {\n    min-height: 100px;\n    padding: 16px;\n  }\n}\n\n/* ==========================================================\n   用户协议样式\n   ========================================================== */\n\n/* 协议勾选区域 */\n.agreement-section {\n  margin: 24px 0 20px;\n  padding: 16px 20px;\n  background: var(--color-surface);\n  border-radius: 16px;\n  border: 1px solid var(--color-border);\n  box-shadow: var(--shadow-sm);\n}\n\n.agreement-checkbox {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  cursor: pointer;\n  line-height: 1.5;\n  font-size: 0.9rem;\n  color: var(--color-text);\n}\n\n.agreement-checkbox input[type=\"checkbox\"] {\n  display: none;\n}\n\n.checkmark {\n  width: 20px;\n  height: 20px;\n  border: 2px solid var(--color-border-strong);\n  border-radius: 4px;\n  background: var(--color-surface);\n  position: relative;\n  flex-shrink: 0;\n  transition: var(--transition-fast);\n  margin-top: 2px;\n}\n\n.checkmark::after {\n  content: '';\n  position: absolute;\n  left: 6px;\n  top: 2px;\n  width: 6px;\n  height: 10px;\n  border: solid white;\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg);\n  opacity: 0;\n  transition: var(--transition-fast);\n}\n\n.agreement-checkbox input[type=\"checkbox\"]:checked + .checkmark {\n  background: var(--color-primary);\n  border-color: var(--color-primary);\n}\n\n.agreement-checkbox input[type=\"checkbox\"]:checked + .checkmark::after {\n  opacity: 1;\n}\n\n.agreement-text {\n  flex: 1;\n  user-select: none;\n}\n\n.agreement-link {\n  background: none;\n  border: none;\n  color: var(--color-primary);\n  text-decoration: underline;\n  cursor: pointer;\n  font-size: inherit;\n  font-family: inherit;\n  padding: 0;\n  margin: 0;\n  transition: var(--transition-fast);\n}\n\n.agreement-link:hover {\n  color: var(--color-primary-accent);\n  text-decoration: none;\n}\n\n/* 模态框样式 */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n  backdrop-filter: blur(4px);\n}\n\n.modal-content {\n  background: var(--color-surface);\n  border-radius: 20px;\n  box-shadow: var(--shadow-lg);\n  max-width: 800px;\n  width: 100%;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid var(--color-border);\n}\n\n.agreement-modal {\n  max-width: 900px;\n}\n\n.modal-header {\n  padding: 20px 24px 16px;\n  border-bottom: 1px solid var(--color-border);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-shrink: 0;\n}\n\n.modal-header h2 {\n  margin: 0;\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: var(--color-text);\n  line-height: 1.3;\n}\n\n.modal-close {\n  background: none;\n  border: none;\n  font-size: 1.8rem;\n  color: var(--color-text-sec);\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 8px;\n  transition: var(--transition-fast);\n  min-width: 36px;\n  min-height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.modal-close:hover {\n  background: var(--color-surface-alt);\n  color: var(--color-text);\n}\n\n.modal-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px 24px;\n}\n\n.agreement-content {\n  line-height: 1.6;\n  color: var(--color-text);\n  font-size: 0.9rem;\n}\n\n.agreement-content p {\n  margin: 0 0 12px;\n  word-wrap: break-word;\n}\n\n.agreement-content p.empty-line {\n  margin: 8px 0;\n  height: 8px;\n}\n\n.agreement-content p:first-child {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: var(--color-primary);\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.modal-footer {\n  padding: 16px 24px 20px;\n  border-top: 1px solid var(--color-border);\n  display: flex;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.modal-btn {\n  padding: 12px 32px;\n  font-size: 1rem;\n  border-radius: 12px;\n  min-width: 120px;\n}\n\n/* 提交按钮状态 */\n.submit-btn:disabled {\n  background: var(--color-surface-alt) !important;\n  color: var(--color-text-sec) !important;\n  cursor: not-allowed !important;\n  opacity: 0.6;\n}\n\n/* 移动端响应式优化 */\n@media (max-width: 480px) {\n  .agreement-section {\n    margin: 20px 0 16px;\n    padding: 14px 16px;\n    border-radius: 14px;\n  }\n\n  .agreement-checkbox {\n    gap: 10px;\n    font-size: 0.85rem;\n  }\n\n  .checkmark {\n    width: 18px;\n    height: 18px;\n  }\n\n  .checkmark::after {\n    left: 5px;\n    top: 1px;\n    width: 5px;\n    height: 9px;\n  }\n\n  .modal-overlay {\n    padding: 16px;\n  }\n\n  .modal-content {\n    border-radius: 16px;\n    max-height: 85vh;\n  }\n\n  .modal-header {\n    padding: 16px 18px 12px;\n  }\n\n  .modal-header h2 {\n    font-size: 1rem;\n    line-height: 1.4;\n  }\n\n  .modal-close {\n    font-size: 1.6rem;\n    min-width: 32px;\n    min-height: 32px;\n  }\n\n  .modal-body {\n    padding: 16px 18px;\n  }\n\n  .agreement-content {\n    font-size: 0.85rem;\n    line-height: 1.5;\n  }\n\n  .agreement-content p:first-child {\n    font-size: 1rem;\n  }\n\n  .modal-footer {\n    padding: 12px 18px 16px;\n  }\n\n  .modal-btn {\n    padding: 10px 24px;\n    font-size: 0.9rem;\n    min-width: 100px;\n  }\n}\n\n@media (max-width: 360px) {\n  .agreement-section {\n    padding: 12px 14px;\n  }\n\n  .agreement-checkbox {\n    font-size: 0.8rem;\n    gap: 8px;\n  }\n\n  .checkmark {\n    width: 16px;\n    height: 16px;\n  }\n\n  .checkmark::after {\n    left: 4px;\n    top: 1px;\n    width: 4px;\n    height: 8px;\n  }\n\n  .modal-overlay {\n    padding: 12px;\n  }\n\n  .modal-header {\n    padding: 14px 16px 10px;\n  }\n\n  .modal-header h2 {\n    font-size: 0.95rem;\n  }\n\n  .modal-body {\n    padding: 14px 16px;\n  }\n\n  .agreement-content {\n    font-size: 0.8rem;\n  }\n\n  .modal-footer {\n    padding: 10px 16px 14px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
